import ExtraCheckModal from "./ExtraCheckModal"

export default ExtraCheckModal;